import { Flex, Link, Button, Heading, Text } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';
import { AvatarImage } from './AvatarImage';
import { Currency } from './Currency';
import { Link as ReactRouterLink } from 'react-router-dom';
import { BrowserView, MobileView } from 'react-device-detect';
import { AuthenticatedComponent } from '../../auth/keycloak';

interface PrivateProfileInfoParams {
    blurb: string;
    username: string;
    imageUrl: string;
}

export const PrivateProfileInfo: AuthenticatedComponent<PrivateProfileInfoParams> = ({
    blurb,
    username,
    imageUrl,
    keycloak,
}) => {
    return (
        <>
            <BrowserView className={'profile-info-browser'}>
                <Flex className={'profile-avatar-container'}>
                    <AvatarImage src={imageUrl} alt={`${username}'s profile photo`} />
                </Flex>
                <Flex className="profile-details-browser">
                    <Heading className="username" size="lg">
                        {username}
                    </Heading>
                    {blurb && <Text className="blurb">{blurb}</Text>}
                    <Currency keycloak={keycloak} refreshFlag={false} quantityCallback={() => {}} />
                    <Link as={ReactRouterLink} to="/profile/edit" className={'edit-profile-link'}>
                        <Button>
                            <FormattedMessage
                                id="private_profile.edit_profile"
                                defaultMessage={'Edit Profile'}
                            />
                        </Button>
                    </Link>
                </Flex>
            </BrowserView>
            <MobileView className="profile-detail">
                {/* note this is column-reverse */}
                <Flex className="profile-column-left">
                    <Flex className="profile-buttons-container">
                        <Flex className={'profile-buttons'}>
                            <Link as={ReactRouterLink} to="/profile/edit">
                                <Button>
                                    <FormattedMessage
                                        id="private_profile.edit_profile"
                                        defaultMessage={'Edit Profile'}
                                    />
                                </Button>
                            </Link>
                        </Flex>
                    </Flex>
                    <Flex className={'profile-avatar-container'}>
                        <AvatarImage src={imageUrl} alt={`${username}'s profile photo`} />
                    </Flex>
                </Flex>
                <Flex className="profile-column-right">
                    <Heading className="username" size="lg">
                        {username}
                    </Heading>
                    {blurb && <Text className="blurb">{blurb}</Text>}
                    <Currency keycloak={keycloak} refreshFlag={false} quantityCallback={() => {}} />
                </Flex>
            </MobileView>
        </>
    );
};
